import React from 'react';
import MaterialSelect from '../components/materialSelect';
import Localization from '../helpers/localization';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GlassWallContainer from '../containers/GlassWallContainer'
const GlassWallSelectionPage = ({ measurementsSkipped, glassMaterials, glassListMaterials, showPrices, doorMaterialChanged, glassListMaterialChanged, glassPrice, doorTypeChanged, doorOptions, selectedMaterial, selectedGlassListMaterial, doorType, showMaterial,showListMaterial, doorImage, prevPage, nextPage }) => (
    <div className="page" id = "glassWallPage">
       <div> 
            {(doorType === "customGlassWall" && !measurementsSkipped) ? <GlassWallContainer></GlassWallContainer> : <img src={doorImage} className="img-fluid"></img>}                   
        </div>
        {showPrices ? <div>Muutoksen vaikutus hintaan: {glassPrice.toFixed(2)}  &euro;</div> : ""}
        <MaterialSelect materials={doorOptions} onChange={doorTypeChanged} selected={doorType} columnNum={5} autoAdjustWidth={true} header={Localization.doorTypeSelectionLabel} ></MaterialSelect>
        {showMaterial ? (
            <Row>
                <Row>
                    <Col md={showListMaterial ? 6: 12}>
                         <MaterialSelect materials={glassMaterials} onChange={doorMaterialChanged} selected={selectedMaterial} header={Localization.glassMaterialHeader} />
                    </Col>
                    {showListMaterial ? (
                        <Col md={6}>
                            <MaterialSelect materials={glassListMaterials} onChange={glassListMaterialChanged} selected={selectedGlassListMaterial} header={Localization.fittingAndListColor} />
                        </Col>) : ""}
                </Row>
            </Row>
        ) : ""}

        <div className="changePhaseRow">
            <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {Localization.prevPhase}</span></span>
            <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {Localization.nextPhase} &#8594;</span></span>
        </div>
    </div>);

export default GlassWallSelectionPage

